import React, { useState, useEffect } from "react";
import axios from "axios";
import {
    Card,
    CardBody,
    Col,
    Row,
    Container,
    Alert,
    Progress,
    Spinner, // Import Spinner for loading indicator
} from "reactstrap";

// Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

const FormAddVideos = () => {
    document.title = "Videos | Uma Classes";

    const [formData, setFormData] = useState({
        title: "",
        description: "",
        categoryId: "",
        subcategoryId: "",
        subSubcategoryId: "",
        file: null,
    });

    const [categories, setCategories] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    const [subSubcategories, setSubSubcategories] = useState([]);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(true);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [isUploading, setIsUploading] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem("token");

        const fetchCategories = async () => {
            try {
                const response = await axios.get(
                    "https://uma.aasmo.in/api/admin/getall-category",
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                setCategories(response); // Set categories from response data
                setLoading(false);
            } catch (error) {
                console.error("Error fetching categories:", error);
                setLoading(false);
            }
        };

        const fetchSubCategories = async () => {
            try {
                const response = await axios.get(
                    `https://uma.aasmo.in/api/admin/getall-subcategory`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                setSubcategories(response); // Set subcategories from response data
            } catch (error) {
                console.error("Error fetching subcategories:", error);
            }
        };

        const fetchSubSubCategories = async () => {
            try {
                const response = await axios.get(
                    `https://uma.aasmo.in/api/admin/getall-subsubcategory`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                setSubSubcategories(response); // Set sub-subcategories from response data
            } catch (error) {
                console.error("Error fetching sub-subcategories:", error);
            }
        };

        fetchCategories();
        fetchSubCategories();
        fetchSubSubCategories();
    }, []);

    const handleCategoryChange = (e) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            categoryId: value,
            subcategoryId: "",
            subSubcategoryId: "",
        });
    };

    const handleSubcategoryChange = (e) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            subcategoryId: value,
            subSubcategoryId: "",
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,  // Set the value for all form fields, including 'videoUrl'
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Check if videoUrl is not empty before submitting
        if (!formData.videoUrl) {
            setErrorMessage("Please enter a video URL.");
            return;
        }

        try {
            const token = localStorage.getItem("token");

            // Create FormData to submit the form data
            const formDataToSubmit = new FormData();
            formDataToSubmit.append("title", formData.title);
            formDataToSubmit.append("description", formData.description);
            formDataToSubmit.append("category", formData.categoryId);
            formDataToSubmit.append("subcategory", formData.subcategoryId);
            formDataToSubmit.append("subSubcategory", formData.subSubcategoryId);
            formDataToSubmit.append("videoUrl", formData.videoUrl);  // Ensure videoUrl is added here

            setIsUploading(true);

            const response = await axios.post(
                "https://uma.aasmo.in/api/admin/add-video",
                formDataToSubmit,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",  // Ensure it's multipart/form-data for form submission
                    },
                }
            );

            setIsUploading(false);
            setSuccessMessage(response.message || "Video added successfully!");
            setErrorMessage("");
            setFormData({
                title: "",
                description: "",
                categoryId: "",
                subcategoryId: "",
                subSubcategoryId: "",
                videoUrl: "",  // Reset the URL field after submission
            });
        } catch (error) {
            console.error("Error adding video:", error);
            setIsUploading(false);
            setSuccessMessage("");
            setErrorMessage(error.response?.message || "Error adding video");
        }
    };





    if (loading) {
        return <div>Loading categories...</div>;
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs title="Videos" breadcrumbItem="Add" />

                    <Row>
                        <Col>
                            <Card>
                                <CardBody>
                                    <form onSubmit={handleSubmit}>
                                        {/* Form fields */}

                                        {/* Video Title */}
                                        <Row className="mb-3">
                                            <label htmlFor="title" className="col-md-2 col-form-label">
                                                Title
                                            </label>
                                            <div className="col-md-12">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="title"
                                                    name="title"
                                                    value={formData.title}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </Row>

                                        {/* Description */}
                                        <Row className="mb-3">
                                            <label htmlFor="description" className="col-md-2 col-form-label">
                                                Description
                                            </label>
                                            <div className="col-md-12">
                                                <textarea
                                                    className="form-control"
                                                    id="description"
                                                    name="description"
                                                    value={formData.description}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </Row>

                                        {/* Categories */}
                                        {/* Categories */}
                                        <Row className="mb-3">
                                            <label htmlFor="categoryId" className="col-md-2 col-form-label">
                                                Select Category
                                            </label>
                                            <div className="col-md-12">
                                                <select
                                                    id="categoryId"
                                                    name="categoryId"
                                                    className="form-control"
                                                    value={formData.categoryId}
                                                    onChange={handleCategoryChange}
                                                    required
                                                >
                                                    <option value="">Select a category</option>
                                                    {categories.map((category) => (
                                                        <option key={category._id} value={category._id}>
                                                            {category.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </Row>

                                        {/* Subcategories */}
                                        <Row className="mb-3">
                                            <label htmlFor="subcategoryId" className="col-md-2 col-form-label">
                                                Select Subcategory
                                            </label>
                                            <div className="col-md-12">
                                                <select
                                                    id="subcategoryId"
                                                    name="subcategoryId"
                                                    className="form-control"
                                                    value={formData.subcategoryId}
                                                    onChange={handleSubcategoryChange}
                                                    required
                                                >
                                                    <option value="">Select a subcategory</option>
                                                    {subcategories.map((subcategory) => (
                                                        <option key={subcategory._id} value={subcategory._id}>
                                                            {subcategory.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </Row>
                                        <Row className="mb-3">
                                            <label htmlFor="subSubcategoryId" className="col-md-4 col-form-label">
                                                Select Sub-Subcategory
                                            </label>
                                            <div className="col-md-12">
                                                <select
                                                    id="subSubcategoryId"
                                                    name="subSubcategoryId"
                                                    className="form-control"
                                                    value={formData.subSubcategoryId}
                                                    onChange={handleChange}
                                                    required
                                                >
                                                    <option value="">Select a sub-subcategory</option>
                                                    {subSubcategories.map(subSubcategory => (
                                                        <option key={subSubcategory._id} value={subSubcategory._id}>
                                                            {subSubcategory.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </Row>
                                        {/* Select Category, Subcategory, Sub-Subcategory */}

                                        {/* File Upload */}
                                        {/* <Row className="mb-3">
                                            <label htmlFor="file" className="col-md-2 col-form-label">
                                                Upload Video (MP4)
                                            </label>
                                            <div className="col-md-12">
                                                <input
                                                    className="form-control"
                                                    type="file"
                                                    id="file"
                                                    name="file"
                                                    accept="video/mp4"
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </Row> */}
                                        {/* URL Input */}
                                        <Row className="mb-3">
                                            <label htmlFor="videoUrl" className="col-md-2 col-form-label">
                                                Video URL
                                            </label>
                                            <div className="col-md-12">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="videoUrl" // Ensure the ID is 'videoUrl'
                                                    name="videoUrl" // Ensure the name is 'videoUrl'
                                                    value={formData.videoUrl}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </Row>

                                        {/* Progress Bar */}
                                        {isUploading && (
                                            <Row className="mb-3">
                                                <div className="col-md-12">
                                                    <Progress value={uploadProgress}>
                                                        {uploadProgress}%
                                                    </Progress>
                                                </div>
                                            </Row>
                                        )}

                                        {/* Success & Error Messages */}
                                        {successMessage && <Alert color="success">{successMessage}</Alert>}
                                        {errorMessage && <Alert color="danger">{errorMessage}</Alert>}

                                        {/* Loading Spinner */}
                                        {isUploading && (
                                            <div className="text-center my-3">
                                                <Spinner color="primary" /> Uploading video...
                                            </div>
                                        )}

                                        {/* Submit Button */}
                                        <Row>
                                            <div className="col-md-12">
                                                <button type="submit" className="btn btn-primary">
                                                    Add Video
                                                </button>
                                            </div>
                                        </Row>
                                    </form>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default FormAddVideos;
